<ng-container *ngIf="country === 'ch'">
  <div class="login font-efSans">
    <div class="login-info-panel">
      <div class="icon">
        <mat-icon svgIcon="info"></mat-icon>
      </div>
      <div class="login-info">
        <T
          str="No myEmil Frey customer account yet? No problem! We will be happy to set it up for you in your Emil Frey garage. Even without a customer login, you can send your request quickly and easily online. And should you buy the car of your dreams, your Emil Frey customer advisor will automatically set up your personal login when you hand over the vehicle in the on-site garage."
          key="customerPortal.kc.login.greeting"
          tags="kc-forms, 3.2"
        ></T>
      </div>
    </div>

    <div class="login-form-container">
      <div class="welcome">
        <div class="welcome-title ef-small-heading-black-1">
          <T
            str="Welcome back!"
            key="customerPortal.kc.welcome.back"
            tags="kc-forms, 3.2"
          ></T>
        </div>
      </div>

      <div class="form-container">
        <form
          class="flex flex-col gap-3 revolution-form"
          #loginFormCh
          [formGroup]="form"
          method="POST"
          [action]="viewData.loginAction"
          (ngSubmit)="loginCh()"
        >
          <mat-form-field class="email">
            <mat-label>{{ 'email' | sharedTranslate }}</mat-label>
            <mat-icon matPrefix svgIcon="alternate_email"></mat-icon>
            <input
              class="username input"
              matInput
              type="email"
              required
              email
              formControlName="email"
              name="username"
              placeholder="{{ 'email' | sharedTranslate }}"
            />
            <mat-icon
              *ngIf="form.controls.email.touched && form.controls.email.invalid"
              matSuffix
              color="error"
              svgIcon="error_outline"
            ></mat-icon>
          </mat-form-field>
          <mat-form-field class="password">
            <mat-label>{{ 'password' | sharedTranslate }}</mat-label>
            <mat-icon matPrefix svgIcon="vpn"></mat-icon>
            <input
              [type]="showPassword ? 'text' : 'password'"
              class="password input"
              matInput
              type="password"
              required
              minlength="8"
              formControlName="password"
              name="password"
              placeholder="{{ 'password' | sharedTranslate }}"
            />
            <mat-icon
              *ngIf="
                form.controls.password.touched && form.controls.password.invalid
              "
              matSuffix
              color="error"
              svgIcon="error_outline"
            ></mat-icon>

            <mat-icon
              *ngIf="!showPassword"
              class="togglePasswordIcon"
              matSuffix
              svgIcon="visibility_off"
              (click)="toggleShowPassword()"
            >
            </mat-icon>
            <mat-icon
              *ngIf="showPassword"
              class="togglePasswordIcon"
              matSuffix
              svgIcon="visibility_on"
              (click)="toggleShowPassword()"
            ></mat-icon>
          </mat-form-field>

          <customer-portal-kc-message></customer-portal-kc-message>

          <button
            class="login-button"
            type="submit"
            [disabled]="!form.valid || loginStarted"
          >
            <span>{{
              {
                str: 'Login',
                key: 'customerPortal.kc.login.button'
              } | transifexTranslate
            }}</span>
          </button>
        </form>
      </div>
      <div
        class="forgot-password py-4 flex justify-center text-mat-ef-revolution-secondary-500 font-semibold text-sm"
      >
        <a [href]="resetPasswordUrl" target="_blank">{{
          {
            str: 'Forgot password',
            key: 'customerPortal.kc.login.forgot-password'
          } | transifexTranslate
        }}</a>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="country === 'de'">
  <div class="login de">
    <div class="login-form-container py-10 px-0 md:px-10 rounded-lg">
      <div class="welcome">
        <div
          class="welcome-title text-3xl font-canelablack text-mat-ef-revolution-primary-900"
        >
          {{
            {
              str: 'I already have an account',
              key: 'customerPortal.kc.login.subtitle'
            } | transifexTranslate
          }}
        </div>
      </div>

      <div class="form-container">
        <form
          class="login-form de"
          #loginFormDe
          [formGroup]="form"
          method="POST"
          [action]="viewData.loginAction"
          (ngSubmit)="loginDe()"
        >
          <mat-form-field class="username no-padding" floatLabel="never">
            <input
              class="input"
              matInput
              type="email"
              required
              email
              formControlName="email"
              name="username"
              placeholder="{{ 'email' | sharedTranslate }}"
            />
          </mat-form-field>
          <mat-form-field class="password no-padding" floatLabel="never">
            <input
              [type]="showPassword ? 'text' : 'password'"
              class="input"
              matInput
              type="password"
              required
              minlength="8"
              formControlName="password"
              name="password"
              placeholder="{{ 'password' | sharedTranslate }}"
            />

            <mat-icon
              *ngIf="!showPassword"
              class="togglePasswordIcon"
              matSuffix
              svgIcon="visibility_off"
              (click)="toggleShowPassword()"
            >
            </mat-icon>
            <mat-icon
              *ngIf="showPassword"
              class="togglePasswordIcon"
              matSuffix
              svgIcon="visibility_on"
              (click)="toggleShowPassword()"
            ></mat-icon>
          </mat-form-field>
          <mat-checkbox
            color="primary"
            class="remember"
            *ngIf="realmData.rememberMe"
            name="rememberMe"
            >{{
              {
                str: 'Remember me',
                key: 'customerPortal.kc.login.remember-me'
              } | transifexTranslate
            }}</mat-checkbox
          >
          <customer-portal-kc-message></customer-portal-kc-message>
          <button
            class="login-button"
            type="submit"
            [disabled]="!form.valid || loginStarted"
          >
            <span>{{
              {
                str: 'Login',
                key: 'customerPortal.kc.login.button'
              } | transifexTranslate
            }}</span>
          </button>
        </form>
      </div>

      <div
        class="forgot-password py-4 flex justify-center text-mat-ef-revolution-secondary-500 font-semibold text-sm"
      >
        <a [href]="resetPasswordUrl" target="_blank">{{
          {
            str: 'Forgot password',
            key: 'customerPortal.kc.login.forgot-password'
          } | transifexTranslate
        }}</a>
      </div>

      <div class="flex pb-4 justify-center font-semibold text-sm">
        <T
          str="Don't have an account yet?"
          key="customerPortal.kc.login.have-account"
          tags="kc-forms, 3.2"
        ></T
        >&nbsp;
        <div class="forgot-password text-mat-ef-revolution-secondary-500">
          <a [href]="registrationUrl" target="_top">{{
            {
              str: 'Register',
              key: 'customerPortal.kc.register.button'
            } | transifexTranslate
          }}</a>
        </div>
      </div>
    </div>
  </div>
</ng-container>
